import Typography from '@components/basics/typography';
import AppState from '@webapp/store/state';
import { NotificationType } from '@webapp/types/ui/toast-notification-type';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import styled, { useTheme } from 'styled-components';

interface SmallNotificationProps {
  className?: string;
  title?: React.ReactNode;
  isMobile?: boolean;
  notificationType?: NotificationType;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const SmallNotification: FunctionComponent<SmallNotificationProps> = (
  props
) => {
  const theme = useTheme();
  return (
    <div className={props.className || ''}>
      <Typography color={theme.colors.black}>{props.title}</Typography>
    </div>
  );
};

export default connect(mapStateToProps)(styled(SmallNotification)`
  padding: 20px 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ theme }) => theme.zIndices.header};

  background: ${({ theme, notificationType }) =>
    notificationType === 'success'
      ? theme.colors.greenLight
      : notificationType === 'error'
      ? theme.colors.pink
      : theme.colors.hint};

  ${(props) =>
    props.isMobile &&
    `
  position: fixed;
  bottom: 40px;
  right: 10%;
  width: 60%;
`}
  ${(props) =>
    !props.isMobile &&
    `
  position: fixed;
  bottom: 40px;
  left: 10%;
  transform: translate(-50%, 0);

  @media ${({ theme }) => theme.device.tablet} {
    padding: 15px;
  }
`}
`);
